import { createFileRoute } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import Cables from 'pages/Cables'
import CablesClassic from 'pages/Cables/Cables.classic'

const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/cables/')({
  component: IS_CLASSIC_UI ? CablesClassic : Cables,
})
